/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamRevisionBotexamidVisualize200,
  GetApiV1ExamRevisionBotexamidVisualize400,
  GetApiV1ExamRevisionBotexamidVisualize401,
  GetApiV1ExamRevisionBotexamidVisualize404,
  GetApiV1ExamRevisionBotexamidVisualize500,
  GetApiV1ExamRevisionBotexamidVisualizePathParams,
  GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
  GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamidVisualize.ts";
import { classroomDisciplineBotExamVisualizationViewModelSchema } from "../classroomDisciplineBotExamVisualizationViewModelSchema.ts";

export const getApiV1ExamRevisionBotexamidVisualizePathParamsSchema = z.object({
  botExamId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualizePathParams>;

export const getApiV1ExamRevisionBotexamidVisualizeQueryParamsSchema = z.object(
  {
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(1),
  },
) as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualizeQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamRevisionBotexamidVisualize200Schema = z.lazy(
  () => classroomDisciplineBotExamVisualizationViewModelSchema,
) as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualize200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamRevisionBotexamidVisualize400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualize400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamRevisionBotexamidVisualize401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualize401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamRevisionBotexamidVisualize404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualize404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamRevisionBotexamidVisualize500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualize500>;

export const getApiV1ExamRevisionBotexamidVisualizeQueryResponseSchema = z.lazy(
  () => getApiV1ExamRevisionBotexamidVisualize200Schema,
) as unknown as ToZod<GetApiV1ExamRevisionBotexamidVisualizeQueryResponse>;
